import WithLayout from "../src/components/Hoc/withLayout";
import ConsoleLandingPage from "../src/components/ConsoleHome";
import authRoute from "../src/components/Authentication/authRoute";

const IndexPage = () => {
  return <ConsoleLandingPage />;
};

export default authRoute(WithLayout(IndexPage, "Home"));
